import { render, staticRenderFns } from "./crm-phone-number-input.vue?vue&type=template&id=2dabf09a&"
import script from "./crm-phone-number-input.vue?vue&type=script&lang=js&"
export * from "./crm-phone-number-input.vue?vue&type=script&lang=js&"
import style0 from "./crm-phone-number-input.vue?vue&type=style&index=0&id=2dabf09a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports